import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  Calendar,
  HeartHandshake,
  Building
} from "lucide-react";

const officeHours = [
  { day: "Monday - Friday", hours: "9:00 AM - 4:00 PM" },
  { day: "Saturday", hours: "9:00 AM - 3:00 PM" },
  { day: "Sunday", hours: "CLOSED" }
];

const medicalFacilities = [
  "Mesa View Quick Care Family Practice in Logandale",
  "Lin's Pharmacy in Overton",
  "Fit Physical Therapy in Overton",
  "Mesa View Regional Hospital in Mesquite",
  "North Las Vegas VA Medical Center",
  "IHC Hospital in St. George, UT",
  "St. George Regional Hospital"
];

export function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Contact & Reservations
          </h2>
          <p className="text-lg text-muted-foreground">
            Ready to experience the Fun 'n Sun difference? Get in touch with us today!
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Contact Information */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-primary" />
                Contact Information
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-primary" />
                <div>
                  <p className="font-medium">Office Phone</p>
                  <a href="tel:+17023978894" className="text-primary hover:underline">
                    (702) 397-8894
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-primary" />
                <div>
                  <p className="font-medium">Email</p>
                  <a href="mailto:fun_n_sun@mvdsl.com" className="text-primary hover:underline">
                    fun_n_sun@mvdsl.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-primary mt-1" />
                <div>
                  <p className="font-medium">Location</p>
                  <p className="text-muted-foreground text-sm">
                    Overton, Nevada<br />
                    Lower Moapa Valley
                  </p>
                </div>
              </div>

              <Button className="w-full mt-6">
                Make Reservation
              </Button>
            </CardContent>
          </Card>

          {/* Office Hours */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Clock className="h-5 w-5 text-primary" />
                Office Hours
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              {officeHours.map((schedule, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="font-medium">{schedule.day}</span>
                  <span className="text-muted-foreground">{schedule.hours}</span>
                </div>
              ))}
              
              <div className="border-t pt-4 mt-6">
                <div className="flex items-center gap-2 mb-2">
                  <Calendar className="h-4 w-4 text-primary" />
                  <span className="font-medium">Check-in/Check-out</span>
                </div>
                <p className="text-sm text-muted-foreground">
                  Check-in: After 12:00 PM<br />
                  Check-out: Before 11:00 AM<br />
                  <span className="text-primary">(After hours self check-in available)</span>
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Medical Facilities */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <HeartHandshake className="h-5 w-5 text-primary" />
                Medical Facilities Nearby
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {medicalFacilities.map((facility, index) => (
                  <div key={index} className="flex items-start gap-2 text-sm">
                    <Building className="h-3 w-3 text-primary mt-1 flex-shrink-0" />
                    <span className="text-muted-foreground">{facility}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-16">
          <Card className="max-w-2xl mx-auto bg-primary/5 border-primary/20">
            <CardContent className="p-8">
              <h3 className="text-2xl font-semibold mb-4">
                Ready to Make Memories?
              </h3>
              <p className="text-muted-foreground mb-6 leading-relaxed">
                The Fun 'n Sun Mobile Home and RV Park is not just a place to park your RV - 
                It's a place to relax, connect and create lasting memories right in the heart of Overton, Nevada, 
                where the summer sun spends the winter.
              </p>
              <p className="text-primary font-medium text-lg">
                We look forward to seeing you soon!
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}